export type FestivalSlugMeta = {
    type: 'LONG';
    year: number;
};

const LONG_FESTIVAL_SLUG_PREFIX = 'festival';

export const makeFestivalSlug = (type: 'LONG' | string, year: number): string => {
    if (type === 'LONG') {
        return `${LONG_FESTIVAL_SLUG_PREFIX}-${year}`;
    }
    return `${type.toLowerCase()}-${year}`;
};

export const parseFestivalSlug = (slug: string): FestivalSlugMeta | null => {
    const normalized = slug.trim().toLowerCase();
    const longMatch = normalized.match(/^festival-(\d{4})$/);

    if (longMatch) {
        return {
            type: 'LONG',
            year: Number(longMatch[1]),
        };
    }

    return null;
};
